import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import ClientLogin from '../../components/ClientLogin';
import ClientRegister from '../../components/ClientRegister';
import InsideHeader from '../../components/InsideHeader';
import HOAPortal from '../../components/HOAPortal';
import { colors } from '../../styles';


const styles = css`
  background-color: ${colors.color4};
  color: #FFFFFF;
  .Favorites_contentSection {
    margin: 60px 0 20px 0;
    @media(min-width: 992px) {
      margin: 40px auto;
    }
  }
  .Favorites_introBody {
    display: block;
    font-weight: 300;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 25px;
    padding: 10px 15px;
    @media(min-width: 992px) {
      font-size: 18px;
      line-height: 30px;
      padding: 0 5%;
    }

    @media(min-width: 1400px) {
      padding: 0 5%;
      font-size: 20px;
      font-weight: 200;
      line-height: 40px;
    }
  }
  .Favorites_mainBody {
    font-weight: 300;
    font-size: 16px;
    line-height: 30px;
    @media(min-width: 992px) {
      font-size: 18px;
      line-height: 35px;
    }
  }

  .LoginRegister {
    display:flex;
    flex-flow:row wrap;
    justify-content: center;
  }

  .LoginRegister-Login, .LoginRegister-Register {
    width:100%;
    @media (min-width: 768px) {
      width:50%;
    }
  }

`;

function ResidentLogin({ page, user, userError }) {
  return (
    <div className={styles}>
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          title={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        {
          user &&
          <HOAPortal />
        }
        <div className="container Favorites_contentSection mx-auto">
          <div className="row">
            <div className="Favorites_introBody col-lg-12 text-center">
              {get(page, 'lead_copy')}
            </div>
            {
              !user && get(page, 'body_copy') &&
                <div className="Favorites_mainBody col-lg-12" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} />
            }
          </div>
        </div>

        {
          get(page, 'settings[0].require_login') &&
          !user &&
          <div className="LoginRegister container">
            <div className="LoginRegister-Login">
              <ClientLogin
                user={user}
                userError={userError}
              />
            </div>
            <div className="LoginRegister-Register">
              {
                !user &&
                <ClientRegister serviceName="Realtor Request Form" />
              }
            </div>
          </div>
        }
      </PageWrapper>
    </div>
  );
}

ResidentLogin.propTypes = {
  page: PropTypes.object.isRequired,
  user: PropTypes.object,
  userError: PropTypes.object,
};

ResidentLogin.defaultProps = {
  user: undefined,
  userError: undefined,
};

export default withData(
  {
    page: 'resident_login',
    user: true,
    userError: true,
  },
  {
    required: {
      page: true,
    },
  },
)(ResidentLogin);



// WEBPACK FOOTER //
// ./src/pages/ResidentLogin/index.js